import { apiUrls } from '@/constant/configure';
import api from '@/helpers/api_helper';
import currentMallStore from '@/store/modules/currentMallStore';

export const checkMallPermission = async (mallId: string) => {
    try {
        const { ownMallList } = await api.get('/mall/own-mall').then((r) => {
            return r.data;
        });

        //@ts-ignore
        const mallList = ownMallList?.length
            ? ownMallList.find((o: any) => o?.mallId && o?.mallId === mallId && o.runningState === 'COMPLETED')
            : undefined;

        return !!mallList?.length ? mallList[0]?.mallRole : undefined;
    } catch (e) {
        console.error(e);
    }
};

export interface MallInfoResponse {
    name: string;
    description: string;
    snsInfo?: {
        snsName: string;
        url?: string;
    }[];
    backgroundColor?: string;
    backgroundImage?: string;
    profileImage?: string;
    mallReturnAddressInfo: {
        postCode: string;
        recipientAddress: string;
        recipientAddressDetail: string;
    };
}
export const getMallInfo = async (mallId: string, isStore: boolean = true): Promise<MallInfoResponse> => {
    try {
        console.log('%c getMallInfo-call', 'color:green', mallId);

        const mallInfo = await api.get(`/mall/${mallId}`).then((r) => {
            return r.data?.mallInfo || r.data;
        });

        const { setCurrentMall } = currentMallStore.getState();

        if (isStore) setCurrentMall(mallInfo);

        console.log('%c getMallInfo-succeed', 'color:green', mallInfo);

        return mallInfo;
    } catch (e) {
        //@ts-ignore
        if (e?.status === 422 || e?.status === 400) {
            throw {
                status: 404,
                message: 'This Store is Not Found',
            };
        } else {
            throw e;
        }
    }
};

export interface PatchMallPayload {
    name?: string;
    description?: string;
    snsInfo?: {
        snsName: string;
        url?: string;
    }[];
    backgroundColor?: string;
    backgroundImage?: string;
    profileImage?: string;
    mallReturnAddressInfo?: {
        postCode: string;
        recipientAddress: string;
        recipientAddressDetail: string;
    };
}
export const patchMallInfo = async (mallId: string, data: PatchMallPayload) => {
    try {
        const res = await api.patch(`/mall/${mallId}`, data);

        console.log('patchMallInfo-res', res);
    } catch (e) {
        throw e;
    }
};

export const getBusinessInfo = async (mallId: string) => {
    try {
        console.log('getBusinessInfo-call', { mallId });
        return await api.get(`/mall/${mallId}/business-info`).then((r) => {
            console.log('getBusinessInfo-res', r);

            return r.data?.mallBusinessInfo || r.data;
        });
    } catch (e) {
        throw e;
    }
};

export interface PatchMallBusinessInfoPayload {
    settleBank?: string;
    settleBankCode?: string;
    settleAccountNumber?: string;
    settleAccountOwnerName?: string;
    settleBankBookUrl?: string;
    businessType?: string;
    businessItem?: string;
    companyName?: string;
    ownerName?: string;
    businessRegistrationNumber?: string;
    mailOrderSalesRegistrationNumber?: string;
    managerPhoneNumber?: string;
    customerCenterNumber?: string;
    companyAddress?: string;
    // businessInfoType?: string;
    // vendorCode?: string
    businessRegistrationCertificateUrl?: string;
    mailOrderSalesRegistrationCertificateUrl?: string;
}
export const patchMallBusinessInfo = async (mallId: string, data: PatchMallBusinessInfoPayload) => {
    try {
        await api.patch(`/mall/${mallId}/business-info`, data).then((r) => {
            console.log(r);
            return r;
        });
    } catch (e) {
        throw e;
    }
};

interface SalesPolicyData {
    rewardMileageRate: number;
    description: string;
    isDummy?: boolean;
}
export const getSalesPolicy = async (mallId: string): Promise<SalesPolicyData> => {
    try {
        return await api.get(`/mall/${mallId}/sales-policy`).then((r) => {
            return r.data?.salesPolicyInfo || r.data;
        });
    } catch (e: any) {
        if (e?.status === 422) {
            console.log('default 값을 리턴할까?');
            return {
                rewardMileageRate: 0,
                description: '<p>default text</p>',
                isDummy: true,
            };
        }

        throw e;
    }
};

interface PostSalesPolicyBody {
    rewardMileageRate: number;
    description: string;
}
export const postSalesPolicy = async (mallId: string, data: PostSalesPolicyBody) => {
    try {
        return await api.post(`/mall/${mallId}/sales-policy`, data).then((r) => {
            return r.data;
        });
    } catch (e) {
        console.error(e);
    }
};
interface PatchSalesPolicyBody {
    rewardMileageRate?: number;
    description?: string;
}
export const patchSalesPolicy = async (mallId: string, data: PatchSalesPolicyBody): Promise<SalesPolicyData> => {
    try {
        return await api.patch(`/mall/${mallId}/sales-policy`, data).then((r) => {
            return r.data;
        });
    } catch (e) {
        throw e;
    }
};

export const getShippingPolicyList = async (mallId: string) => {
    try {
        return await api.get(`/mall/${mallId}/shipping-policy`).then((r) => {
            return r.data?.shippingPolicyList || r.data;
        });
    } catch (e) {
        throw e;
    }
};

export interface PostShippingPolicyPayload {
    title: string;
    shippingCost: number;
    islandMountainShippingCost: number;
    freeShippingCostBar: number;
    islandMountainDiscountShippingCostBar: number;
    islandMountainDiscountPrice: number;
}
export const postShippingPolicy = async (mallId: string, data: PostShippingPolicyPayload) => {
    try {
        return await api.post(`/mall/${mallId}/shipping-policy`, data).then((r) => {
            const responseData = r.data;
            return {
                id: responseData.policyId,
            };
        });
    } catch (e) {
        throw e;
    }
};

export const patchShippingPolicy = async (mallId: string, policyId: string, data: PostShippingPolicyPayload) => {
    try {
        return await api.patch(`/mall/${mallId}/shipping-policy/${policyId}`, data).then((r) => {
            return r.data;
        });
    } catch (e) {
        throw e;
    }
};

export const deleteShippingPolicy = async (mallId: string, policyId: string) => {
    try {
        return await api.delete(`/mall/${mallId}/shipping-policy/${policyId}`).then((r) => {
            return r.data || true;
        });
    } catch (e) {
        throw e;
    }
};

export const getNoticeList = async (mallId: string) => {
    try {
        return await api.get(`/mall/${mallId}/notification`).then((r) => {
            return {
                list: r.data?.notificationList || [],
            };
        });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export type PostNoticeRequestBody = {
    title: string;
    body: string;
    isPinned: boolean;
};
export const postNotice = async (mallId: string, data: PostNoticeRequestBody) => {
    try {
        return await api.post(`/mall/${mallId}/notification`, data).then((r) => {
            return r?.data || true;
        });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export type PatchNoticeRequestBody = {
    title?: string;
    body?: string;
    isPinned?: boolean;
};
export const patchNotice = async (mallId: string, noticeId: string, data: PatchNoticeRequestBody) => {
    try {
        return await api.patch(`/mall/${mallId}/notification/${noticeId}`, data).then((r) => {
            return r?.data || true;
        });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const deleteNotice = async (mallId: string, noticeId: string) => {
    try {
        return await api.delete(`/mall/${mallId}/notification/${noticeId}`).then((r) => {
            return r?.data || true;
        });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const getNewInquiryCount = async (mallId: string) => {
    try {
        return await api.get(`mall/${mallId}/inquiry/unanswered-count`).then((r) => {
            return r.data || { unansweredCount: 0 };
        });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const getCheckIsReturnIssue = async (mallId: string) => {
    try {
        return await api.get(`mall/${mallId}/order-group/return/new/check`).then((r) => r.data?.isNew || false);
    } catch (e) {
        return false;
    }
};

export const getProductDetail = async ({ mallId, productId }: { mallId: string; productId: string }) => {
    try {
        return (
            await api.get(`mall/${mallId}/product/${productId}/detail`, {
                baseURL: apiUrls.mall_main,
            })
        )?.data;
    } catch (e) {
        throw e;
    }
};

const mallServices = {
    checkMallPermission,
    getMallInfo,
    patchMallInfo,
    getBusinessInfo,

    getSalesPolicy,
    postSalesPolicy,
    patchSalesPolicy,

    getShippingPolicyList,
    postShippingPolicy,
    patchShippingPolicy,
    deleteShippingPolicy,

    getNoticeList,
    postNotice,
    patchNotice,
    deleteNotice,
};

export default mallServices;
